define('core/views/VineRichMediaView',[
    'core/views/AutoplayRichMediaView',
    'core/utils',
], function (
    AutoplayRichMediaView,
    utils
) {
    'use strict';

    return AutoplayRichMediaView.extend({
        createContentNode: function () {
            // Vine videos have audio disabled by default. If this video is
            // being shown as the result of an expand event, enable the audio.
            var $node = AutoplayRichMediaView.prototype.createContentNode.apply(this, arguments);
            var src = $node.attr('src');
            if (this.shouldAutoplay() && src) {
                src = utils.serialize(src, {
                    audio: 1,
                });
                $node.attr('src', src);
            }
            return $node;
        },
    });
});


